(function() {
    'use strict';

    var ContattiCtrl = function(
        messaggiFctr,
        contattiService,
        gestioneUtenteService
    ) {
        this.loading = 0;
        this.contattiService = contattiService;

        this.listaNumeriTelefono = [];
        this.emailCertificata = false;
        this.listaCertificazioni = [];
        this.principaleRequired = true;
        this.gestioneUtenteService = gestioneUtenteService;

        this.init = () => {
            if (!this.gestioneUtenteService.datiMito.elencoContatti) {
                this.gestioneUtenteService.datiMito.elencoContatti = [];
            }
            gestioneUtenteService.datiMito.elencoContatti.forEach((c) => {
                this.listaNumeriTelefono.push(false);
                this.listaCertificazioni.push(false);
            });
            this.getPrefissi();
            this.checkPrincipaleRequired();
        };

        this.getPrefissi = () => {
            if (!contattiService.listaPrefissi || !contattiService.listaPrefissi.length) {
                contattiService.getPrefissi().then(
                    (resp) => {
                        resp.data.forEach((prefisso) => {
                            contattiService.listaPrefissi.push({ cod: prefisso.valore, dsc: prefisso.descrizione });
                        });

                        this.rivalutaNumeri();
                    },
                    (error) => messaggiFctr.processaResponse(error)
                );
            } else {
                this.rivalutaNumeri();
            }
        };

        this.rivalutaNumeri = () => {
            this.gestioneUtenteService.datiMito.elencoContatti.forEach((contatto) => {
                let prefisso = null;
                let numero = contatto.numero;
                if (numero.startsWith('+')) {
                    if (contattiService.listaPrefissi && (contattiService.listaPrefissi.length > 0)) {
                        prefisso = contattiService.listaPrefissi.find(elem => {
                            return numero.startsWith(elem.cod, 1);
                        });
                    }
                    if (!!prefisso){
                        contatto.prefisso = prefisso.cod;
                        contatto.numero = numero.substring(prefisso.cod.length + 1);
                    }
                }
            });
            this.getCertificazioneContatto();
        };

        this.getCertificazioneContatto = () => {
            if (!gestioneUtenteService.datiMito.ndg) return;
            contattiService.getCertificazioneContatto(gestioneUtenteService.datiMito.ndg)
            .then(
                (resp) => {
                    gestioneUtenteService.datiMito.elencoContatti.forEach((contatto, indice) => {
                        if (resp.data.result.telefono.replace('+', '').trim() === contatto.prefisso.replace('+', '').trim() + contatto.numero.trim())
                            this.listaCertificazioni[indice] = resp.data.result.telefonoCertificato;
                    });
                    if (resp.data.result.email.toLowerCase().trim() === gestioneUtenteService.datiMito.email.toLowerCase().trim())
                        this.emailCertificata = true;
                },
                (error) => messaggiFctr.processaResponse(error)
            )
        };

        this.aggiungiContatto = () => {
            this.gestioneUtenteService.datiMito.elencoContatti.push({
                prefisso: '',
                numero: '',
                principale: 0
            });
            this.listaNumeriTelefono.push(true);
            this.listaCertificazioni.push(false);
        };

        this.rimuoviContatto = (index) => {
            this.gestioneUtenteService.datiMito.elencoContatti.splice(index, 1);
            this.listaNumeriTelefono.splice(index, 1);
            this.listaCertificazioni.splice(index, 1);
            this.checkPrincipaleRequired();
        };

        this.setPreferito = (numero) => {
            this.gestioneUtenteService.datiMito.elencoContatti.forEach((num) => {
                num.principale = 0;
            });
            numero.principale = 1;
            this.principaleRequired = false;
        };

        this.checkPrincipaleRequired = () => {
            this.principaleRequired = true;
            this.gestioneUtenteService.datiMito.elencoContatti.forEach((num) => {
                if (!!num.principale) {
                    this.principaleRequired = false;
                }
            });
        };

        this.init();
    };

    ContattiCtrl.$inject = [
        'MitomMessaggiFctr',
        'MitomContattiService',
        'MitomGestioneUtenteService'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-utente/mitoman-dati-utente-mito/mitoman-contatti/contatti.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var ContattiComponent = {
        controller: ContattiCtrl,
        controllerAs: 'contattiCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomcontatti', ContattiComponent);
})();